<template>
  <div style="padding-right: 10px;display: inline-block;">
    <div style="display: flex;justify-content: space-between;">
      {{ (grossMarginText || 0.00) }} {{ showB ?'%':'' }}
    </div>
  </div>
</template>

<script>
import ChargeCurrencyTotalGroupHP from './ChargeCurrencyTotalGroupHP.js'
import ChargeCountItemRenderer from './ChargeCountItemRenderer'
export default {
  components: { ChargeCountItemRenderer },
  props: {
    dataProvider: { type: Array, default: () => [], required: false }, // 数据源
    isCalculateExcludingAmount: { type: Boolean, default: () => true, required: false } // 是否按照含税价计算，默认是
  },
  data() {
    return {
      chargeCurrencyTotalGroupHP: null,
      grossMarginText: 0.00,
      showB: true,
      chargeCurrencyTotalGroupData: {}
    }
  },
  computed: {
  },
  watch: {
    dataProvider(val) {
      // console.log('totalGroup watch dataProvider', val)
      // console.log('watch dataProvider000--', val)
      this.chargeCurrencyTotalGroupHP.dataProvider = val
      this.chargeCurrencyTotalGroupHP.grossMarginRecalc(this.isCalculateExcludingAmount)
      this.grossMarginText = this.chargeCurrencyTotalGroupHP.grossMargin
      this.showB = this.chargeCurrencyTotalGroupHP.showB
    }
  },
  created() {
    this.chargeCurrencyTotalGroupData = {
      type: this.type,
      dataProvider: this.dataProvider, // 数据源
      grossMargin: this.grossMarginText,
      showB: true
    }
    this.chargeCurrencyTotalGroupHP = new ChargeCurrencyTotalGroupHP(this.chargeCurrencyTotalGroupData)
    this.chargeCurrencyTotalGroupHP.grossMarginRecalc(this.isCalculateExcludingAmount)
    this.grossMarginText = this.chargeCurrencyTotalGroupHP.grossMargin
    this.showB = this.chargeCurrencyTotalGroupHP.showB
  },
  methods: {

  }

}
</script>

<style scoped>

</style>
